import { render, staticRenderFns } from "./MyASINs.vue?vue&type=template&id=2382fa85&scoped=true"
import script from "./MyASINs.vue?vue&type=script&lang=js"
export * from "./MyASINs.vue?vue&type=script&lang=js"
import style0 from "./MyASINs.vue?vue&type=style&index=0&id=2382fa85&prod&scoped=true&lang=css"
import style1 from "./MyASINs.vue?vue&type=style&index=1&id=2382fa85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2382fa85",
  null
  
)

export default component.exports